import React from 'react';

const Play = () => <>Page</>;

export default Play;
